import React from "react";
import styled from "styled-components";

const TableWrapper = styled.div`
  overflow-x: auto;
  max-height: 60vh;
  overflow-y: auto;
  margin-bottom: 32px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 8px rgb(0 0 0 / 0.1);
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #ddd;
    font-size: 14px;
  }

  th {
    background: #f4f4f4;
    font-weight: 600;
    position: sticky;
    top: 0;
    z-index: 10;
  }

  img {
    width: 50px;
    height: auto;
    border-radius: 4px;
  }
`;

export default function ProductDetailsTable() {
  const products = [
    {
      id: 1,
      name: "Comprehensive Auto",
      ref: "AUTO123",
      underwriters: "ABC Insurance",
      productImage: "https://via.placeholder.com/50?text=Auto",
    }
  ];

  return (
    <TableWrapper>
      <Table>
        <thead>
          <tr>
            <th>Product Image</th>
            <th>Name</th>
            <th>Underwriters</th>
            <th>Ref</th>
          </tr>
        </thead>
        <tbody>
          {products.map((item) => (
            <tr key={item.id}>
              <td>
                <img src={item.productImage} alt={item.name} />
              </td>
              <td>{item.name}</td>
              <td>{item.underwriters}</td>
              <td>{item.ref}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </TableWrapper>
  );
}
